// src/components/LoginPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LuxuryLoadingScreen from "./LoadingPage";
import "./LoginPage.css";
import { getClientByEmail, getClientProfile } from "../apiService";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleView = async () => {
    setError("");
    if (!email.trim()) {
      setError("Please enter your email");
      return;
    }
    setIsLoading(true);
    localStorage.clear(); // <-- ADD THIS
    try {
      const data = await getClientByEmail(email);
      console.log("Client by email:", data);
      if (data.total_count === 0) {
        setError("No account found for this email.");
        setIsLoading(false);
        return;
      }
      const womanId = data.objects[0].id;
      console.log("Found client ID:", womanId);

      const profileData = await getClientProfile(womanId);
      console.log("Received profile data:", profileData);

      const swipeCount = profileData.SwipeCount ? parseInt(profileData.SwipeCount, 10) : 0;
      console.log("SwipeCount:", swipeCount);

      localStorage.setItem("womanId", womanId.toString());
      localStorage.setItem("swipeCount", swipeCount.toString());
      localStorage.removeItem("swipeLimit"); // No longer needed
      localStorage.setItem("womanZip", "10001");

      navigate("/loading");
    } catch (err) {
      console.error("Error in handleView:", err);
      setError("Error checking your account. Please try again later.");
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <LuxuryLoadingScreen />;
  }

  return (
    <div className="login-page">
      <img src="/logos/bond_logo_white.png" alt="Bond Logo" className="logo-welcome" />
      <label htmlFor="email-input" className="email-label">My Email Is</label>
      <input
        id="email-input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="email-input"
      />
      {error && <div className="error-message">{error}</div>}
      <div className="info-container">
        <p className="info-text">
          Ladies are complimentary in our network. View premier matches to stay active.
        </p>
      </div>
      <button onClick={handleView} className="view-button">View</button>
    </div>
  );
};

export default LoginPage;